<template>
    <div class="footer-area-wrapper" :class="FooterStyle">

        <div class="footer-copyright-area border-top section-space--ptb_30">
            <div class="container">
                <div class="footer-widget__logo">
                    <router-link to="/">
                        <img src="../assets/img/logo/logo-dark.png" class="img-fluid logo-dark" alt="logo">
                        <img src="../assets/img/logo/logo-light.png" class="img-fluid logo-light" alt="logo">
                    </router-link>
                </div>
                <div class="row align-items-center">
                    <div class="col-md-6 text-center text-md-left">
                        <span class="copyright-text">
                            &copy; 2024 <b>codeperf.io</b> Made with <i class="fa fa-heart text-danger"></i> in
                            <b>Portugal</b></span>
                    </div>

                    <div class="col-md-6 text-center text-md-right">
                        <ul class="list ht-social-networks solid-rounded-icon">

                            <li class="item">
                                <a href="https://twitter.com/codeperfio" target="_blank" class="social-link"> <i
                                        class="fab fa-twitter social-link-icon"></i> </a>
                            </li>
                            <li class="item">
                                <a href="https://www.github.com/codeperfio" target="_blank" class="social-link"> <i
                                        class="fab fa-github-alt social-link-icon"></i> </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FooterMain',
    props: ["FooterStyle"]
}
</script>
